export const CURRENCY_SYMBOLS = {
  KGS: 'с', USD: '$', RUB: '₽', EUR: '€', CNY: '¥', KZT: '₸', UZS: 'сўм'
};

export function formatAmount(amount, code) {
  const upper = (code || 'KGS').toUpperCase();
  const isKgs = upper === 'KGS';
  const formatter = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: isKgs ? 0 : 2,
    maximumFractionDigits: isKgs ? 0 : 2
  });
  return `${formatter.format(amount)} ${CURRENCY_SYMBOLS[upper] || upper}`;
}
